var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M458.7,259.1c-5.1-22.4-23.4-38.9-45.4-41.3C361.2,212,308.6,212,256,212s-105.2,0-157.3,5.8 c-21.9,2.4-40.3,18.9-45.4,41.3c-7.3,31.8-7.5,66.6-7.5,99.3s0,67.5,7.3,99.3c5.1,22.4,23.4,38.9,45.4,41.3 c52.1,5.8,104.8,5.8,157.3,5.8s105.2,0,157.3-5.8c21.9-2.4,40.3-18.9,45.4-41.3c7.3-31.8,7.3-66.6,7.3-99.3 C466.1,325.7,466.1,291,458.7,259.1z M165.8,283.8h-30.4v161.5h-28.3V283.8H77.3v-26.5h88.5V283.8z M242.5,445.4H217v-15.3 c-10.1,11.6-19.7,17.3-29.1,17.3c-8.1,0-13.8-3.3-16.4-10.5c-1.3-4.2-2.2-10.9-2.2-20.8V305.3h25.4v103.1c0,5.9,0,9,0.2,9.9 c0.6,3.9,2.6,5.9,5.9,5.9c5.1,0,10.5-3.9,16-11.9V305.2h25.4L242.5,445.4z M339,403.3c0,12.9-0.9,22.3-2.6,28.3 c-3.3,10.5-10.1,15.7-20.3,15.7c-9,0-17.7-5-26.3-15.5v13.6h-25.4v-188h25.4v61.5c8.2-10.1,16.9-15.1,26.3-15.1 c10.1,0,16.9,5.3,20.3,15.8c1.7,5.7,2.6,14.9,2.6,28.2V403.3z M434.7,379.9h-50.8v24.8c0,12.9,4.2,19.5,12.9,19.5 c6.2,0,9.9-3.5,11.4-10.1c0.2-1.3,0.6-7,0.6-17.1h25.9v3.7c0,8.1-0.3,13.8-0.6,16.4c-0.9,5.6-2.9,10.7-5.9,15.3 c-7,10.1-17.5,15.1-30.7,15.1c-13.2,0-23.4-4.8-30.7-14.4c-5.3-7-8.1-18-8.1-33V351c0-15,2.4-25.9,7.8-33.1 c7.3-9.6,17.5-14.4,30.4-14.4c12.7,0,22.8,4.8,29.9,14.4c5.3,7.1,7.9,18,7.9,33.1V379.9L434.7,379.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M396.7,326.4c-8.5,0-12.7,6.5-12.7,19.5v12.9h25.4v-12.9C409.3,332.8,405.1,326.4,396.7,326.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M302.5,326.4c-4.2,0-8.5,2-12.7,6.1v85.4c4.2,4.2,8.5,6.2,12.7,6.2c7.3,0,11-6.2,11-18.9v-59.8 C313.6,332.8,309.8,326.4,302.5,326.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M316.7,199.1c9.4,0,19-5.7,29.3-17.4v15.5h25.6V55.6H346v108.2c-5.7,8-11,12-16.3,12c-3.5,0-5.5-2-6-6 c-0.3-0.9-0.3-4-0.3-10V55.6h-25.6v112c0,10,0.9,16.8,2.2,21C302.8,195.8,308.4,199.1,316.7,199.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.1,120.2v76.9h28.5v-76.9l34.2-113h-28.7l-19.4,74.6L132.5,7.2h-29.9c6,17.6,12.2,35.3,18.3,52.9 C129.8,86.7,135.6,106.6,138.1,120.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.9,199.1c12.8,0,22.8-4.8,29.9-14.5c5.3-7.1,8-18.3,8-33.3v-49.5c0-15.1-2.6-26.2-8-33.4 c-7.1-9.7-17-14.5-29.9-14.5c-12.8,0-22.8,4.8-29.8,14.5c-5.5,7.1-8,18.3-8,33.4v49.5c0,15,2.6,26.2,8,33.3 C216.2,194.3,226.1,199.1,238.9,199.1z M226.6,96.6c0-13.1,4-19.6,12.2-19.6c8.2,0,12.2,6.6,12.2,19.6v59.6 c0,13.1-4,19.7-12.2,19.7c-8.2,0-12.2-6.6-12.2-19.7V96.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.a06a29f752ec66f7a3b5cad2ff713915.svg";
export { ForwardRef as ReactComponent };